/**
 * The server's error message from a failed request, or `fallback`.
 *
 * A `catch` binding is `unknown` under `strict`, so every one of these sites
 * would otherwise need its own cast. One helper keeps the assertion in a single
 * place instead of scattering `(e as any)` through the pages.
 */
export function apiErrorMessage(e: unknown, fallback: string): string {
  return (e as any)?.response?.data?.error ?? fallback;
}

/**
 * Extracts a server error message from an axios failure.
 * Handles `responseType: 'blob'` requests, where error bodies come back
 * as Blobs rather than parsed JSON.
 */
export async function blobErrorMessage(e: any, fallback: string): Promise<string> {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text())?.error ?? fallback;
    } catch {
      return fallback;
    }
  }
  return data?.error ?? fallback;
}
